import { render, staticRenderFns } from "./MBtnNormalComp.vue?vue&type=template&id=654a9164&"
import script from "./MBtnNormalComp.vue?vue&type=script&lang=js&"
export * from "./MBtnNormalComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports